import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const root: SxProps<Theme> = (theme) => ({
  display: { xs: "flex", md: "none" },
  position: "fixed",
  bottom: 0,
  insetInline: 0,
  zIndex: theme.zIndex.appBar,
  height: 64,
  bgcolor: "background.paper",
  borderTop: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[4],
  px: 1,
  pb: "env(safe-area-inset-bottom, 0px)",
});

export const navItem =
  (active: boolean): SxProps<Theme> =>
  (theme) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.375,
    fontSize: "0.65625rem",
    fontWeight: active ? 600 : 400,
    color: active ? "primary.main" : "text.secondary",
    textDecoration: "none",
    // Also used on the "More" <button>.
    border: "none",
    bgcolor: "transparent",
    cursor: "pointer",
    fontFamily: "inherit",
    py: 0.75,
    borderRadius: 1,
    transition: "all 0.2s ease",
    "&:hover": {
      bgcolor: alpha(theme.palette.primary.main, 0.06),
    },
  });

export const sheetPaper: SxProps<Theme> = {
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  px: 2,
  pt: 1.25,
  pb: "calc(16px + env(safe-area-inset-bottom, 0px))",
};

export const sheetHandle: SxProps<Theme> = (theme) => ({
  width: 40,
  height: 4,
  borderRadius: 2,
  bgcolor: theme.palette.divider,
  mx: "auto",
  mb: 1.5,
});

export const sheetTitle: SxProps<Theme> = {
  fontSize: "0.875rem",
  fontWeight: 700,
  color: "text.primary",
  mb: 1,
  px: 0.5,
};

export const sheetList: SxProps<Theme> = {
  listStyle: "none",
  m: 0,
  p: 0,
  display: "flex",
  flexDirection: "column",
  gap: 0.75,
};

export const sheetItem =
  (active: boolean): SxProps<Theme> =>
  (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    px: 1.25,
    py: 1.25,
    borderRadius: 1.5,
    textDecoration: "none",
    color: active ? "primary.main" : "text.primary",
    bgcolor: active ? alpha(theme.palette.primary.main, 0.06) : "transparent",
    "&:hover": {
      bgcolor: alpha(theme.palette.primary.main, 0.06),
    },
  });

export const sheetIconWrap =
  (active: boolean): SxProps<Theme> =>
  (theme) => ({
    width: 38,
    height: 38,
    borderRadius: 1.25,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    bgcolor: active ? alpha(theme.palette.primary.main, 0.12) : theme.palette.background.default,
  });

export const sheetLabel: SxProps<Theme> = {
  flex: 1,
  fontSize: "0.84375rem",
  fontWeight: 600,
};
